import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    sarchKeyWord: "",
    tabeSarch: "All",
    startDate: "",
    endDate: "",
    page: 1,
};

const campaignDashbordSlice = createSlice({
    name: "campaignDashbord",
    initialState,
    reducers: {
        setTabeSarch: (state, action) => {
            state.tabeSarch = action.payload
        },
        setSarchKeyWord: (state, action) => {
            state.sarchKeyWord = action.payload
        },
        setStartDate: (state, action) => {
            state.startDate = action.payload
        },
        setEndDate: (state, action) => {
            state.endDate = action.payload
        },
        setpage: (state, action) => {
            state.page = action.payload
        },
        resetcampaignDashbord: (state) => {
            state.sarchKeyWord = initialState.sarchKeyWord;
            state.tabeSarch = initialState.tabeSarch;
            state.startDate = initialState.startDate;
            state.endDate = initialState.endDate;
            state.page = initialState.page;
        }
    }
});


export const {
    setSarchKeyWord,
    setTabeSarch,
    setStartDate,
    setEndDate,
    setpage,
    resetcampaignDashbord
} = campaignDashbordSlice.actions;

export default campaignDashbordSlice.reducer;

